import { ExchangeRates, UnavailableDateError } from '~/Api/User/ExchangeRate';
import { RatesSettings } from '~/Api/User/ProductGroup/ExchangeRatesSettings';

export enum ActionType {
	request = 'ExchangeRates.request',
	receive = 'ExchangeRates.receive',
	requestCreate = 'ExchangeRates.requestCreate',
	receiveCreate = 'ExchangeRates.receiveCreate',
	requestUpdate = 'ExchangeRates.requestUpdate',
	receiveUpdate = 'ExchangeRates.receiveUpdate',
	requestUpdateGroupRates = 'ExchangeRates.requestUpdateGroupRates',
	receiveUpdateGroupRates = 'ExchangeRates.receiveUpdateGroupRates',
}

export interface RequestAction {
	date: Date | null;
	groupId: string;
	rateType: string | null;
	request: Promise<any>;
	type: ActionType.request;
	userId: string;
}

export interface ReceiveAction {
	date: Date | null;
	request: Promise<any>;
	type: ActionType.receive;
	rates: ExchangeRates[] | null;
	unavailableDateError: UnavailableDateError | null;
}

export interface RequestCreateAction {
	type: ActionType.requestCreate;
	request: Promise<any>;
}

export interface ReceiveCreateAction {
	type: ActionType.receiveCreate;
	request: Promise<any>;
	rates: ExchangeRates | null;
}

export interface RequestUpdateAction {
	type: ActionType.requestUpdate;
	request: Promise<any>;
}

export interface ReceiveUpdateAction {
	type: ActionType.receiveUpdate;
	request: Promise<any>;
	rates: ExchangeRates | null;
}

export interface RequestUpdateGroupRatesAction {
	type: ActionType.requestUpdateGroupRates;
	request: Promise<any>;
}

export interface ReceiveUpdateGroupRatesAction {
	type: ActionType.receiveUpdateGroupRates;
	request: Promise<any>;
	userId: string;
	groupId: string;
	settings: RatesSettings | null;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| RequestCreateAction
	| ReceiveCreateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| RequestUpdateGroupRatesAction
	| ReceiveUpdateGroupRatesAction;
